import { useState } from "react";
import {
  ContentContainer,
  ContentMenu,
  ContentBody,
} from "@/pages/layouts/main-content";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  // DropdownMenuLabel,
  // DropdownMenuPortal,
  // DropdownMenuSeparator,
  // DropdownMenuShortcut,
  // DropdownMenuSub,
  // DropdownMenuSubContent,
  // DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronsUpDown, MessageCirclePlus, Settings } from "lucide-react";
import { useTranslation } from "@/providers/language-provider";
import { useSignals } from "@preact/signals-react/runtime";
import { ChatList } from "@/pages/subs/chats/chat-list";
import { ChatView } from "@/pages/subs/chats/chat-view";
import { useChats } from "@/providers/chat-provider";
import { DialogChat } from "@/features/dialog-chat";
import { OpenProfile } from "@/pages/layouts/main-header";
import { cn } from "@/lib/utils";

export function MainChats({ hidden }: { hidden?: boolean }) {
  useSignals();
  const { t } = useTranslation();
  const { currentChat } = useChats();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editChat, setEditChat] = useState<any>(null);

  // 대화 만들기, 수정하기
  const handleOpenDialog = (chat: any) => {
    // 대화가 선택되었고, 친구라면
    if (chat?.friend) {
      // 프로필 대화상자를 보여준다.
      OpenProfile(chat.friend);
      return;
    }

    // 새로 만들기 또는 설정
    setEditChat(chat);
    setIsDialogOpen(true);
  };

  const handleSaveChat = (chatData: any) => {
    // 채팅방 저장 로직 구현
    console.log("Saved chat:", chatData);
  };

  return (
    <ContentContainer hidden={hidden}>
      {/* Left pane - 모바일에서 채팅 선택시 숨김, 데스크탑에서는 항상 표시 */}
      <ContentMenu
        className={cn(
          "w-full md:w-[280px]", // 모바일에서 전체폭, md 이상에서 280px
          "md:block", // md 이상에서는 항상 표시
          currentChat ? "hidden" : "block", // 모바일에서 채팅 선택시 숨김
        )}
      >
        <div className="w-full border-b">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="w-full items-center justify-between py-6"
              >
                <h3 className="text-xl font-semibold">{t("Chats")}</h3>
                <ChevronsUpDown className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56">
              <DropdownMenuGroup>
                <DropdownMenuItem onClick={() => handleOpenDialog(null)}>
                  <MessageCirclePlus />
                  <span>{t("NewChat")}</span>
                  {/* <DropdownMenuShortcut>⇧⌘P</DropdownMenuShortcut> */}
                </DropdownMenuItem>
                <DropdownMenuItem
                  disabled={!currentChat}
                  onClick={() => handleOpenDialog(currentChat)}
                >
                  <Settings />
                  <span>{t("EditChat")}</span>
                  {/* <DropdownMenuShortcut>⌘B</DropdownMenuShortcut> */}
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>

        <DialogChat
          chat={editChat}
          isOpen={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSaveChat}
        />

        <div className="flex-1 overflow-hidden">
          <ChatList />
        </div>
      </ContentMenu>

      {/* Right pane - 모바일에서 채팅 선택시 전체화면, 미선택시 숨김 */}
      <ContentBody
        className={cn(
          // "flex-1", // 남은 공간 차지
          // "w-full", // 전체 폭 사용
          "h-full overflow-hidden", // 전체 높이 사용, 스크롤 숨김
          !currentChat ? "hidden md:block" : "block", // 모바일에서 채팅 미선택시 숨김
        )}
      >
        <ChatView chatSettings={handleOpenDialog} />
      </ContentBody>
    </ContentContainer>
  );
}
